import {Button, ButtonGroup, FormButton} from 'platform/components';

import {VehicleFinancingTemplateFormFooterState} from '@dms/features/vehicle-financing-template';
import i18n from '@dms/i18n';

interface EmbeddedTemplateFormFooterProps {
  footer: VehicleFinancingTemplateFormFooterState;
  onDiscard: VoidFunction;
}

/**
 * The dialog's own save bar for the embedded template form. The shared form is layout-agnostic, so
 * the actions live with the surface that owns them.
 */
export function EmbeddedTemplateFormFooter(props: EmbeddedTemplateFormFooterProps) {
  return (
    <ButtonGroup align="right">
      <Button
        title={i18n.t('general.actions.discard')}
        variant="secondary"
        isDisabled={props.footer.isSaving}
        onClick={props.onDiscard}
      />
      <FormButton
        control={props.footer.control}
        type="submit"
        title={i18n.t('page.vehicle.financingAndLeasing.saveConfiguration')}
        isLoading={props.footer.isSaving}
        isDisabled={props.footer.isOptionsLoading}
      />
    </ButtonGroup>
  );
}
